import { backendFetch } from '../../../backend/backend';
import React, { useState, useEffect, Fragment } from 'react';

import { TSTable, TSCell } from '../../ui/TableStructure';
import { TableRow } from '@mui/material';
import dateFormatter from '../../../utils/dateFormatter';

const StatsDoubles=()=>{
	const [doubles,setDoubles]=useState();

	useEffect(()=>{
		const fetchData=async ()=> {
			setDoubles((await backendFetch('stats/doubles')).reverse());	 // reverse to show most recent at the top
		}
		fetchData();
	},[]);

	return(
		<Fragment>
			{doubles &&
				<TSTable title="Double Winners on the Night" headings={["Date","Winner","Host"]} sx={{width:{xs:"100%",sm:565}}}>
					{doubles.map((d)=>(
						<TableRow key={d.date}>
							<TSCell>{dateFormatter(d.date)}</TSCell>
							<TSCell>{d.player}</TSCell>
							<TSCell>{d.host}</TSCell>
						</TableRow>
					))}
				</TSTable>
			}
		</Fragment>
	)
}

export default StatsDoubles;
